import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

/**
 * Compact step indicator for phones (replaces dense MUI Stepper).
 */
export default function MobileProgress({ step, total, label }) {
  const pct = total > 0 ? Math.round(((step + 1) / total) * 100) : 0;
  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.75 }}>
        <Typography variant="caption" sx={{ fontWeight: 800, color: 'primary.main', letterSpacing: 0.4 }}>
          Step {step + 1} of {total}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
          {label}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={pct}
        sx={{
          height: 6,
          borderRadius: 3,
          bgcolor: 'action.hover',
          '& .MuiLinearProgress-bar': { borderRadius: 3 },
        }}
      />
    </Box>
  );
}
